module.exports = __webpack_public_path__ + "img/hz_24.41dcbdda.jpg";